import {
  BufferAttribute,
  BufferGeometry,
  Color,
  Points,
  PointsMaterial,
} from 'three';

function randRange(a, b) {
  return a + Math.random() * (b - a);
}

function addStarLayer(scene, starPointTexture, n, spread, size, opacity, tint) {
  const positions = new Float32Array(n * 3);
  const colors = new Float32Array(n * 3);
  const color = new Color(tint);
  for (let i = 0; i < n; i++) {
    positions[i * 3] = (Math.random() - 0.5) * spread;
    positions[i * 3 + 1] = (Math.random() - 0.5) * spread;
    positions[i * 3 + 2] = (Math.random() - 0.5) * spread;
    const k = randRange(0.55, 1);
    colors[i * 3] = color.r * k;
    colors[i * 3 + 1] = color.g * k;
    colors[i * 3 + 2] = color.b * k;
  }
  const geo = new BufferGeometry();
  geo.setAttribute('position', new BufferAttribute(positions, 3));
  geo.setAttribute('color', new BufferAttribute(colors, 3));
  const pts = new Points(
    geo,
    new PointsMaterial({
      map: starPointTexture,
      size,
      transparent: true,
      opacity,
      vertexColors: true,
      depthWrite: false,
      sizeAttenuation: true,
    }),
  );
  pts.name = 'starfield-layer';
  scene.add(pts);
  return pts;
}

export function addStarfield(scene, starPointTexture) {
  addStarLayer(scene, starPointTexture, 1700, 380, 0.16, 0.42, 0xb9c7ff);
  addStarLayer(scene, starPointTexture, 650, 260, 0.22, 0.62, 0xffffff);
  addStarLayer(scene, starPointTexture, 90, 180, 0.34, 0.82, 0xfff0c8);
}
